<script>
  export default {
    props: {
      item: Object,
      relatorio: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data() {
      return {
        configuracao: this.$storage.configuracao()
      }
    },
    methods: {
      classeCuidadoEspecial(valor) {
        return valor ? 'fa-check-square-o' : 'fa-square-o';
      }
    }
  }
</script>

<template>
    <div>
        <dl v-if="configuracao.solicitacaoUtilizaSelecaoTipoCompra">
            <dt>Tipo de compra</dt>
            <dd>Compras Internas</dd>
        </dl>

        <dl v-if="item.projetoMetaEtapa !== null">
            <dt>Meta etapa</dt>
            <dd>{{ `${item.projetoMetaEtapa.meta.nome} - ${item.projetoMetaEtapa.etapa.nome}` }}</dd>
        </dl>

        <div class="row" v-if="item.rubrica !== null">
            <dl class="col-xs-6">
                <dt>Rubrica</dt>
                <dd>{{ item.rubrica.nome }}</dd>
            </dl>

            <dl class="col-xs-6">
                <dt>Subrubrica</dt>
                <dd>{{ item.subrubrica.nome }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idTipoProduto > 0">
            <dl class="col-xs-12">
                <dt>Tipo de produto</dt>
                <dd>{{ item.tipoProduto ? item.tipoProduto.nomeTipoProduto : "---" }}</dd>
            </dl>
        </div>

        <div class="row" v-if="item.idProduto > 0">
            <dl class="col-xs-12">
                <dt>Produto</dt>
                <dd>{{ item.produto ? item.produto.nome : "---" }}</dd>
            </dl>
        </div>

        <dl>
            <dt>Descrição do material/serviço</dt>
            <dd class="white-space-pre">{{ item.descricao }}</dd>
        </dl>

        <div class="row">
            <dl :class="[configuracao.utilizarValorEstimado ? 'col-xs-4' : 'col-xs-6']">
                <dt>Quantidade</dt>
                <dd>{{ item.quantidade || '---' }}</dd>
            </dl>

            <dl :class="[configuracao.utilizarValorEstimado ? 'col-xs-4' : 'col-xs-6']">
                <dt>Unidade</dt>
                <dd>{{ item.unidade || '---' }}</dd>
            </dl>

            <dl class="col-xs-4" v-if="configuracao.utilizarValorEstimado">
                <dt>Valor estimado</dt>
                <dd>{{ item.valorEstimado ? `R$ ${item.valorEstimado}` : '---' }}</dd>
            </dl>
        </div>

        <dl v-if="!configuracao.solCompraOcultarObservacoes">
            <dt>Observação do item de compra</dt>
            <dd class="white-space-pre">{{ item.observacaoItemCompra || '---' }}</dd>
        </dl>

        <dl>
            <dt v-if="relatorio">Cuidado especial da carga durante o transporte ou manuseio:</dt>
            <dt v-else>
                Caso esta carga precise de algum cuidado especial durante o
                transporte ou manuseio, por favor, marque quais:
            </dt>
            <dd class="row">
                <div class="col-sm-4">
                    <i class="fa" :class="classeCuidadoEspecial(item.controleTermico)"></i> Controle térmico <br>
                    <i class="fa" :class="classeCuidadoEspecial(item.fragil)"></i> Frágil <br>
                    <i class="fa" :class="classeCuidadoEspecial(item.controladoPoliciaFederal)"></i> Controlado pela Polícia Federal
                </div>

                <div class="col-sm-4">
                    <i class="fa" :class="classeCuidadoEspecial(item.solventeReagente)"></i> Solvente/Reagente <br>
                    <i class="fa" :class="classeCuidadoEspecial(item.inflamavel)"></i> Inflamável <br>
                    <i class="fa" :class="classeCuidadoEspecial(item.controladoExercito)"></i> Controlado pelo Exército
                </div>

                <div class="col-sm-4">
                    <i class="fa" :class="classeCuidadoEspecial(item.toxico)"></i> Tóxico <br>
                    <i class="fa" :class="classeCuidadoEspecial(item.vivoPerecivel)"></i> Vivo/Perecível <br>
                    <i class="fa" :class="classeCuidadoEspecial(item.naoSeAplica)"></i> Não se aplica
                </div>
            </dd>
        </dl>

        <dl>
            <dt>Objetivo/Justificativa da compra</dt>
            <dd class="white-space-pre">{{ item.objetivoCompra || '---' }}</dd>
        </dl>

        <dl>
            <dt>Local que o material será alocado</dt>
            <dd class="white-space-pre">{{ item.localAlocado || '---' }}</dd>
        </dl>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-compra/componentes/compartilhado/FormListaComprasInternas.vue